import { Typography } from "@material-ui/core";
import React from "react";
import Text from "../../../shared/components/Text";

export const infoDataBankReader = [
  {
    title: <Text tId="HOW_IT_WORKS" />,
    description: (
      <div style={{ display: "box" }}>
        <Typography variant="body2">
          <Text tId="HOW_IT_WORKS_INTRO" />
        </Typography>
        <ul style={{ padding: 0, paddingLeft: 16, margin: 0 }}>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="HOW_IT_WORKS_BANK" />
            </Typography>
          </li>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="HOW_IT_WORKS_LOGIN" />
            </Typography>
          </li>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="HOW_IT_WORKS_IBAN" />
            </Typography>
          </li>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="HOW_IT_WORKS_DONE" />
            </Typography>
          </li>
        </ul>
      </div>
    ),
  },
  {
    title: <Text tId="WHAT_DATA_IS_READ" />,
    description: (
      <ul style={{ padding: 0, paddingLeft: 16, margin: 0 }}>
        <li>
          <Typography variant="body2">
            <Text tId="WHAT_DATA_IS_READ_IDENTIFICATION" />
          </Typography>
        </li>
        <li style={{ paddingTop: 4 }}>
          <Typography variant="body2">
            <Text tId="WHAT_DATA_IS_READ_STATEMENTS" />
          </Typography>
        </li>
        <li style={{ paddingTop: 4 }}>
          <Typography variant="body2">
            <Text tId="WHAT_DATA_IS_READ_BALANCE" />
          </Typography>
        </li>
      </ul>
    ),
  },
  {
    title: <Text tId="WHICH_GOAL" />,
    description: (
      <>
        <ul style={{ padding: 0, paddingLeft: 16, margin: 0 }}>
          <li>
            <Typography variant="body2">
              <Text tId="WHICH_GOAL_INCOME" />
            </Typography>
          </li>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="WHICH_GOAL_IBAN" />
            </Typography>
          </li>
        </ul>
      </>
    ),
  },
];
